import { atomWithStorage } from "jotai/utils";
import { type MeReadDtoLangEnum } from "@/config/apiClient";
import {
  AVAILABLE_LANGS_SET,
  DEFAULT_LANG,
} from "@/constants/languages.constants";

/**
 * Get initial language based on browser preference
 */
const getInitialBrowserLanguage = (): MeReadDtoLangEnum => {
  const browserLang = navigator.language.substring(0, 2).toLowerCase();
  if (AVAILABLE_LANGS_SET.has(browserLang)) {
    return browserLang as MeReadDtoLangEnum;
  }
  return DEFAULT_LANG;
};

/**
 * Atom for auth page language preference
 * Persisted in localStorage with key "kazaar_auth_language"
 * Initialized with browser language or fallback to English
 */
export const authLanguageAtom = atomWithStorage<MeReadDtoLangEnum>(
  "kazaar_auth_language",
  getInitialBrowserLanguage()
);
